import * as React from 'react';
export const currentSvg = React.forwardRef(function currentSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#000',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M23.184 6h-8.51l-2.648 5.62h8.51L23.185 6Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M16.109 21.117c-2.48 0-4.082-1.64-4.082-5.416V11.62H6v4.08C6 21.957 9.967 26 16.109 26c5.454 0 9.307-3.128 9.727-8.201h-5.913c-.267 2.326-1.83 3.318-3.814 3.318Z',
      fill: '#fff',
    }),
  );
});
currentSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var current = {
  category: 'brand',
  colorable: false,
  name: 'current',
  svg: currentSvg,
};
